<template>
  <div>
    <v-dialog v-model="value" persistent>
      <v-card>
        <v-layout style="flex-wrap: wrap-reverse" justify-end>
          <v-flex class="pa-2 form-control" style="max-width: 300px">
            <multiselect
              v-model="papersize"
              :options="papersizeOptions"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
            ></multiselect>
            <!-- <select v-model="papersize" style="display: inline-block">
              <option v-for="option in papersizeOptions" :key="option" :value="option">
                {{ option }}
              </option>
            </select> -->
          </v-flex>
          <v-flex>
            <v-btn color="primary" class="ma-2" :href="pdflink" target="_blank">
              <v-icon class="mr-1">download</v-icon>Download
            </v-btn>
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="closePreview"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-text>
          <!-- <div class="text-xs-center my-4" v-show="!showPreview">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div v-show="showPreview"> -->
          <div v-if="papersize == 'paperang'" class="text-xs-center">
            <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
              >{{ $t('Link Copied') }}!</v-snackbar
            >
            <div style="max-width: 300px; margin: auto">
              <img
                src="/static/img/assets/shop/paperang.jpeg"
                style="width: 100%; max-width: 200px; margin: auto"
              />
              <textarea
                class="form-control pa-1"
                ref="shareLink"
                style="resize: vertical; width: 100%; margin: auto; border: 1px solid #eee"
                onclick="this.select()"
                readonly="true"
                v-model="pdflink"
              ></textarea>
              <div class="text-xs-center">
                <v-btn
                  depressed
                  color="primary"
                  v-clipboard:copy="pdflink"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  <v-icon class="mr-2">content_copy</v-icon>

                  {{ $t('copy link') }}
                </v-btn>
              </div>
              <div class="text-xs-center mt-3 font-weight-bold">ขั้นตอนการใช้งาน Paperang</div>
              <div class="text-xs-left mb-3">
                1. กดคัดลอก URL <br />
                2. เปิด App Paperang เลือกเมนู พิมพ์หน้าเว็บ <br />
                3. วาง URL<br />
                4. สั่งปริ้นท์เลย
              </div>
            </div>
            <v-divider class="mt-3 mb-3"></v-divider>
          </div>
          <div
            style="border: 1px solid #eee"
            class="ma-auto"
            :style="{ 'max-width': papersize == 'paperang' ? '571px' : '100%' }"
          >
            <embed
              @load="onPreviewLoad"
              :key="papersize"
              :src="pdflink"
              style="width: 100%; height: 500px; margin: 0px; padding: 0px"
            />
          </div>
          <!-- </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import config from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'purchase_id'],
  data() {
    return {
      showPreview: false,
      papersizeOptions: [
        'A4',
        'A5',
        'A6',
        'receipt',
        'letter',
        'letter4x6',
        'sticker',
        'sticker4x6',
        'paperang'
      ],
      papersize: 'sticker4x6',
      showCopy: false
    }
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    pdflink() {
      return `${config.serverUrl}shippopaddresslabel?pageid=${this.selectedBot.pageid}&purchase_id=${this.purchase_id}&size=${this.papersize}`
    }
  },
  methods: {
    onPreviewLoad() {
      this.showPreview = true
    },
    closePreview() {
      this.$emit('closePreview')
      this.$emit('input', false)
    },
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onError: function () {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PreviewShippopCover.vue